// import { playIcon } from '@/images'
// import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import Title from '../Title'
import style from './styles/media.module.scss'

interface IProps {
  className?: string
  image: string
  title: string
  id: number
  baseUrl: string
}

const MediaVideoCard = ({
  className = '',
  image,
  title,
  id,
  baseUrl
}: IProps): React.ReactElement => {
  return (
    <a
      href={`${baseUrl}?section_id=${id}`}
      className={classNames({
        [style.photo]: true,
        [className]: Boolean(className)
      })}
      title={title}
    >
      <img
        src={image}
        width='560px'
        height='311px'
        alt={title}
        loading='lazy'
        className={style.photo__image}
      />

      <div className={style.video_content}>
        {/* <GxIcon src={playIcon} className={style.video__icon} /> */}
        <Title type='h3' theme='h5' className={style.video__title}>
          {title}
        </Title>
      </div>
    </a>
  )
}

export default MediaVideoCard
